import { Store, waitFor } from 'utils';
import SelectedPavilionStore from './SelectedPavilionStore';

class WhyStore extends Store {

	getInitialState() {
		return {
			data: null,
			pavilion: null,
			stand: null,
		}
	}

	onWhyDataChanged(state, data) {
		state.data = data;
	}

	onWhyChanged(state, data) {
		var { pavilion, stand } = data;

		state.pavilion = pavilion;
		state.stand = stand;

		var standId = SelectedPavilionStore.getStandId(stand);
		state.standId = standId;

		state.data = null;
	}

	getPavilion() {
		return this.getState().pavilion;
	}
	
	getStand() {
		return this.getState().stand;
	}

	getData() {
		return this.getState().data;
	}

	getStandId() {
		var slug = this.getState().stand;

		if(slug != null) {
			var stand = SelectedPavilionStore.getStands().find((item) => {
				return item.slug == slug;
			})

			if(stand) {
				return stand.id;
			}
		}
		return null;
	}

	getPerks() {
		var data = this.getData();

		if(data) {
			return data.standPerks;
		} else {
			return [];
		}
	}

	getBenefits() {
		var data = this.getData();

		if(data) {
			return data.standBenefits;
		} else {
			return [];
		}
	}

	getTestimonials() {
		var data = this.getData();

		if(data) {
			return data.standTestimonials;
		} else {
			return []
		}
	}
}

const store = new WhyStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/whystore.js